import type { StoreState } from './types/state';

const getters = {
  // 第二件半价完整的规则描述（带换行标签）
  ruleFlagDesc: (state: StoreState) => {
    if (
      !state.halfPriceRule ||
      !state.halfPriceRule.description ||
      !state.halfPriceRule.threshold_price ||
      !state.halfPriceRule.restrict_single ||
      state.halfPriceRule.discount_rule_id !== 1
    ) {
      return '';
    }
    const _price = state.halfPriceRule.all_threshold?.find(
      (item) => item.currency === state.currency.name,
    )?.price;
    if (!_price) return '';
    const _currencyPrice = `${state.currency.symbol_prefix || ''}${_price}${state.currency.symbol_suffix || ''}`;
    const count = state.halfPriceRule.restrict_single;
    const countText = `${count} ${count === 1 ? 'frame' : 'frames'}`;
    return state.halfPriceRule.description
      .replace(/\${price}/g, _currencyPrice)
      .replace(/\${count}/g, countText);
  },
  /** 购物车 Order Summary 顶部 tips 标题：取 m_global `rule_flag.cart_top_text` */
  ruleCartTipsHalfSummary: (state: StoreState) => {
    if (state.halfPriceRule?.rule_flag !== 1 || state.halfPriceRule.discount_rule_id !== 1) {
      return '';
    }
    const t = state.halfPriceRule?.cart_top_text;
    return typeof t === 'string' ? t.trim() : '';
  },
  /** 购物车侧栏「第二件半价」活动主文案（魔方 cart_top_text）。 */
  cartPromoTopLine: (state: StoreState) => {
    const r = state.halfPriceRule;
    if (r?.rule_flag !== 1 || r.discount_rule_id !== 1 || !r.cart_top_text) {
      return { text: '', isHtml: false };
    }
    const ratio = r.discount_ratio_text?.trim();
    const text = ratio
      ? r.cart_top_text.replace(/\$\{percent(?:age)?\}/gi, ratio)
      : r.cart_top_text;
    return { text, isHtml: false };
  },
  // 购物车推荐区域标题
  ruleCartRecommendTitle: (state: StoreState) => {
    if (state.halfPriceRule?.discount_rule_id !== 1) return '';
    const _title = state.halfPriceRule.cart_recommend_text?.title || '';
    if (!_title || !state.halfPriceRule?.discount_ratio_text) return '';
    return _title.replace(
      /\${percentage}/g,
      `<span style="color: ${state.halfPriceRule.cart_recommend_text?.percentage_color || '#fe5000'}">${state.halfPriceRule.discount_ratio_text}</span>`,
    );
  },
  // 购物车推荐区域副标题
  ruleCartRecommendContent: (state: StoreState) => {
    if (state.halfPriceRule?.discount_rule_id !== 1) return '';
    const _content = state.halfPriceRule.cart_recommend_text?.content || '';
    const _price = state.halfPriceRule.all_threshold?.find(
      (item) => item.currency === state.currency.name,
    )?.price;
    if (!_content || !_price) return '';
    const _currencyPrice = `${state.currency.symbol_prefix || ''}${_price}${state.currency.symbol_suffix || ''}`;
    return _content.replace(/\${price}/g, _currencyPrice);
  },
};

export default getters;
